import React, { useState, useRef, useEffect, useLayoutEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import IconButton from 'components/atoms/Button/IconButton';
import './style.scss';
import { disableAllMenu } from 'modules/actions/statusMenu';
// import { sendQuality, setQuality, setResponse } from 'modules/actions/quality';
import { chatList, insertChat } from 'modules/actions/chat';
import moment from 'moment';
import PropTypes from 'prop-types';
import { sendOrganization } from 'modules/actions/sendOrganization';
import ReactHtmlParser from 'react-html-parser';
import { debounce } from 'lib';
import axios from 'axios';

const Organization = () => {
  const organizationResult = useSelector(state => state.organizationResult);

  const radio1_ref = useRef();
  const radio2_ref = useRef();
  const radio3_ref = useRef();
  const radio4_ref = useRef();
  const sido_ref = useRef();
  const sigungu_ref = useRef();
  const dong_ref = useRef();
  
  const [sidoSelectOptions, setSidoSelectOptions] = useState([]);
  const [sigunguSelectOptions, setSigunguSelectOptions] = useState([]);
  const [dongSelectOptions, setDongSelectOptions] = useState([]);

  const [dongIsDisabled, setDongIsDisabled] = useState(false);
  const [sigunguIsDisabled, setSigunguIsDisabled] = useState(false);

  const buttonRef= useRef(null);
  useLayoutEffect(() => {
    if(buttonRef.current !== null) buttonRef.current.focus();
  },[])

  const fetchOptions = async (type) => {

    if(type === "sido"){ // useState로 select box 초기화 하면 기존에 선택되어있던 값들이 남아있어서 아래와 같이 초기화함
      setSigunguSelectOptions([]);
      setDongSelectOptions([]);
      setDongIsDisabled(false);
      sigungu_ref.current.value = "";
      dong_ref.current.value = "";
    }else if( type === "radio"){
      setSidoSelectOptions([]);
      setSigunguSelectOptions([]);
      setDongSelectOptions([]);
      sido_ref.current.value = "";
      sigungu_ref.current.value = "";
      dong_ref.current.value = "";
    }

    // 선택영역 value 가져오기
    const radioValue = getCheckedValue();
    const sido = sido_ref.current.value || "";
    const sigungu = sigungu_ref.current.value || "";
    const dong = dong_ref.current.value || "";

    // 등기소 주소 api
    await axios.post('/chat/registration', {
      "registration": radioValue,
      "sido": sido,
      "sigungu": sigungu,
      "dong": dong
    })
    .then(response => {
      if(type === "radio"){ // 라디오 버튼 클릭시
        setSidoSelectOptions(response.data.sido);
        setSigunguSelectOptions(response.data.sigungu);
        setDongSelectOptions(response.data.dong);
      }else if(type === "sido"){ // 시도 select박스 선택시
        if(response.data.sigungu.length === 0) {
          setSigunguIsDisabled(true);
          setDongIsDisabled(true);
        }else{
          setSigunguIsDisabled(false);
          setSigunguSelectOptions(response.data.sigungu);
        }
      }else if(type === "sigungu"){ // 시/군/구 select박스 선택시
        if(response.data.dong.length === 0){
          setDongIsDisabled(true);
        }else{
          setDongIsDisabled(false);
          setDongSelectOptions(response.data.dong);
        }
      }
    }).catch(error => {
      console.log(error);
    })
  }

  const dispatch = useDispatch();
  const endOrganization = (inStr, inType, inLabel) => {
    dispatch(sendOrganization({ status: 'stop' }));
    const paramSet = {
      inType: inType || 'query',
      inStr,
      inLabel,
      parameters: sessionStorage.getItem('address')
        ? {
            latitude_y: sessionStorage.getItem('latitude_y'),
            longitude_x: sessionStorage.getItem('longitude_x'),
            address: sessionStorage.getItem('address'),
            position_status: 'Y',
          }
        : { latitude_y: '', longitude_x: '', position_status: 'N' },
    };
    dispatch(chatList(paramSet));
    dispatch(disableAllMenu());
  };

  // const onKeyPressEvt = e => {
  //   if (e.key === 'Enter' && !e.shiftKey) {
  //   }
  // };
  const searchRegistration = async () => {
    const radioValue = getCheckedValue();
    const radioName = getCheckedName();
    const sido = sido_ref.current.value || "";
    const sigungu = sigungu_ref.current.value || "";
    const dong = dong_ref.current.value || "";

    if(radioValue === ""){
      alert("등기구분을 선택해주세요.");
      return "";
    }
    if(sido === ""){
      alert("시/도를 선택해주세요.");
      return "";
    }
    if(sigungu === "" && !sigunguIsDisabled ){
      alert("시/군/구를 선택해주세요.");
      return "";
    }
    if(dong === "" && !dongIsDisabled){
      alert("읍/면/동을 선택해주세요.");
      return "";
    }

    dispatch(sendOrganization({ status: 'stop' }));
    dispatch(disableAllMenu());
  }

  const getCheckedValue = () => {
    return radio1_ref.current.checked ? radio1_ref.current.value : radio2_ref.current.checked ? radio2_ref.current.value : radio3_ref.current.checked ? radio3_ref.current.value : radio4_ref.current.checked ? radio4_ref.current.value : ""
  }

  const getCheckedName = () => {
    return radio1_ref.current.checked ? radio1_ref.current.dataset.name : radio2_ref.current.checked ? radio2_ref.current.dataset.name : radio3_ref.current.checked ? radio3_ref.current.dataset.name : radio4_ref.current.checked ? radio4_ref.current.dataset.name : ""
  }

  return (
    <div className="organization_bg" >
      <div
        className="_box" aria-modal="true"
        style={{
          height: organizationResult.result.length === 0 ? '600px' : organizationResult.result.length === 1 ? 'calc(100vh - 230px)' : 'calc(100vh - 52px)',
          transition: organizationResult.result.length === 0 ? 'height 0.4s' : 'height 0.2s',
        }}
      >
        <div className="_top">
          <div className="_tit" style={{"textAlign" : "center"}}><span>관할 등기소 찾기</span></div>
          <div className="_close" onClick={() => endOrganization('관할등기소찾기종료', ' query', '관할등기소 찾기 종료')}>
          <button type="button" ref={buttonRef} title="관할등기소 찾기 창 닫기" className="_button_div">
            <div className="_icon"><i className="ri-close-line" style={{"fontWeight": "100"}}/>
            </div>
          </button>
            {/* <IconButton
              icon="ri-close-line"
              styleDef={{fontWeight: 100}}
              title="닫기"
            /> */}
          </div>
        </div>
        <div className="_middle">
          <div className="_member_find_div">
            <div className="_filter_div">
              <div className="_input_div">
                <div className="_tit">등기구분</div>
                <ul className="_item">
                  <li className="label">
                    <input type="radio" ref={radio1_ref} name="select_radio" data-name="부동산 등기" value="all_registration" id="one" onClick={() => fetchOptions("radio")}/>
                    <label style={{marginLeft: "7px"}} htmlFor="one">부동산 등기</label>
                    <div style={{marginLeft: "18px", backgroundColor: "#f9f9f9"}}>- 원칙 : 부동산 소재지 등기소에 접수
                      <br/>- 관련사건 : 부동산 소재지 등기소 중 1곳에 접수 가능
                      <br/>- 상속등기 : 전국 모든 등기소에서 접수 가능</div>
                  </li>
                  <li className="label">
                     <input type="radio" ref={radio2_ref} name="select_radio" data-name="법인 등기(상법)" value="corporate_registration" id="two" onClick={() => fetchOptions("radio")}/>
                    <label style={{marginLeft: "7px"}} htmlFor="two">법인 등기(상법)</label>
                  </li>
                  <li className="label">
                    <input type="radio" ref={radio3_ref} name="select_radio" data-name="법인 등기(민법)" value="all_registration" id="three" onClick={() => fetchOptions("radio")}/>
                    <label style={{marginLeft: "7px"}} htmlFor="three">법인 등기(민법)</label>
                  </li>
                  <li className="label">
                    <input type="radio" ref={radio4_ref} name="select_radio" data-name="그 외 등기" value="corporate_registration" id="four" onClick={() => fetchOptions("radio")}/>
                    <label style={{marginLeft: "7px"}} htmlFor="four">그 외 등기</label>
                  </li>
                </ul>
                <div className="_tit">지역 선택</div>
                <ul className="_item">
                  <li className="label">
                    <div className="_tit"><label htmlFor="sido">시/도</label></div>
                    <select name="sido" id="sido" ref={sido_ref} onChange={(e) => fetchOptions("sido")}>
                      <option value="">시/도를 선택해주세요</option>
                      {
                        sidoSelectOptions?.map((data,index) => { 
                          return (
                            <option key={index} value={data}>{data}</option>
                          )
                        })
                      }
                    </select>
                    
                  </li>
                  <li className="label">
                    <div className="_tit"><label htmlFor="sigungu">시/군/구</label></div>
                    <select type="select" ref={sigungu_ref} name="sigungu" disabled={sigunguIsDisabled} id="sigungu" onChange={(e) => fetchOptions("sigungu")}>
                      <option value="">시/군/구를 선택해주세요.</option>
                      {
                        sigunguSelectOptions?.map((data,index)=> { 
                          return (
                            <option key={index} value={data}>{data}</option>
                          )
                        })
                      }
                    </select>
                  </li>
                  <li className="label">
                    <div className="_tit"><label htmlFor="dong">읍/면/동</label></div>
                    <select type="select" ref={dong_ref} name="dong" id="dong" disabled={dongIsDisabled}>
                      <option value="">읍/면/동를 선택해주세요.</option>
                      {
                        dongSelectOptions?.map((data,index)=> { 
                          return (
                            <option key={index} value={data}>{data}</option>
                          )
                        })
                      }
                    </select>
                  </li>
                </ul>
                  <button type="button" className="_btn" title="관할등기소 찾기 검색" onClick={() => searchRegistration()}>
                    <IconButton icon="ri-search-line"  styleDef={{ color: '#FFF' }} title="검색"/>
                    <div className="_label" >검색</div>
                  </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Organization;
